<template>
  <div>
    <div v-if="!error" class="bspeTop">
      <el-row class="bsp-title" type="flex">
        <el-col class="bsp-title-col" :span="12">
          <div style="border-bottom:1px solid #2C2C2C;">
            <r-rich-text-editor :content="title" @onUpdate="updateTitle" />
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="end">
        <el-col :span="10">
          <i style="float: right">{{ savedText }}</i>
        </el-col>
      </el-row>
      <el-row class="editor-row" :gutter="20" style="display: flex; flex-wrap: wrap;">
        <el-col class="editor-context-col" :span="12">
          <el-card class="bibleStudyPlanContextCard" body-style="height: 100%">
            <h4 class="name-of-material">
              {{ !!bibleStudyPlan ? bibleStudyPlan.material.title : '' }}
            </h4>
            <r-rich-text-editor
              class="bsp-context"
              needs-bottom-padding
              :is-editable="false"
              :content="contextEditorText"
            />
          </el-card>
        </el-col>
        <el-col class="editor-dialogue-col" :span="12">
          <el-card class="bibleStudyPlanEditorCard" body-style="height: 100%">
            <r-rich-text-editor
              class="bsp-dialogue"
              bold
              italic
              strikethrough
              underline
              paragraph
              headings
              bulleted-list
              numbered-list
              quote
              horizontal-rule
              history
              needs-bottom-padding
              :content="dialogueEditorText"
              @onUpdate="updateDialogue"
            />
          </el-card>
        </el-col>
      </el-row>
    </div>
    <h3 v-else>
      {{ error }}
    </h3>
  </div>
</template>

<script>
import RichTextEditor from '../../components/Shared/RichTextEditor/RichTextEditor';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const BibleStudyPlansRepository = RepositoryFactory.get('bibleStudyPlans');

export default {
    // inject: ['BibleStudyPlansRepository'],
    components: {
        [RichTextEditor.name]: RichTextEditor,
    },
    data() {
        return {
            bibleStudyPlan: null,
            error: null,
            savedText: '',
            lastSavedTime: null
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        title: {
            get() {
                if (this.bibleStudyPlan) return `<h1>${this.bibleStudyPlan.title}</h1>`;
                return '';
            },
            set(newValue) {
                if (this.bibleStudyPlan) {
                    this.bibleStudyPlan.title = newValue.replace('<h1>', '').replace('</h1>', '');
                    BibleStudyPlansRepository.updateBibleStudyPlan(this.bibleStudyPlan);
                }
            }
        },
        dialogueEditorText: {
            get() {
                if (!this.bibleStudyPlan) { return ''; }

                return this.bibleStudyPlan.dialogue;
            }
        },
        contextEditorText: {
            get() {
                if (!this.bibleStudyPlan) { return ''; }

                return this.bibleStudyPlan.material.context;
            }
        }

    },
    methods: {
        getPlan() {
            BibleStudyPlansRepository.getBibleStudyPlanById(this.id)
                .then((response) => {
                    this.bibleStudyPlan = response;
                    if (!this.lastSavedTime) {
                        this.lastSavedTime = this.bibleStudyPlan.updated_at;
                    }
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        updateTitle(text) {
            this.$message('The Title was updated.');
            if (this.bibleStudyPlan) {
                this.bibleStudyPlan.title = text.replace('<h1>', '').replace('</h1>', '');
                BibleStudyPlansRepository.updateBibleStudyPlan(this.bibleStudyPlan);
            }
        },
        updateDialogue(text) {
            if (this.bibleStudyPlan) {
                this.bibleStudyPlan.dialogue = text;
                this.lastSavedTime = new Date();
                BibleStudyPlansRepository.updateBibleStudyPlan(this.bibleStudyPlan);
            }
        },
    },
    created() {
        this.getPlan();
        setInterval(() => {
            if (!this.bibleStudyPlan) { return; }
            if (this.$moment().diff(this.$moment(this.lastSavedTime), 'seconds') < 2) {
                this.savedText = 'Saved';
            } else {
                this.savedText = `Last saved ${this.$moment(this.lastSavedTime).fromNow()}`;
            }
        }, 1000);
    },
};
</script>\
